import { createAction } from 'redux-actions';

export const getProductListOnDisplayByCompanyRequested = createAction('GET_PRODUCT_LIST_DISPLAY_BY_COMPANY_REQUEST');
export const getProductListOnDisplayByCompanyReceived = createAction('GET_PRODUCT_LIST_DISPLAY_BY_COMPANY_RECEIVED');
export const getProductListOnDisplayByCompanyReceiveFailure = createAction('GET_PRODUCT_LIST_DISPLAY_BY_COMPANY_RECEIVE_FAILURE');
export const getProductListOnDisplayByCompanyClear = createAction('GET_PRODUCT_LIST_DISPLAY_BY_COMPANY_CLEAR');

export const createBusinessContact = createAction('CREATE_BUSINESS_CONTACT');
export const createBusinessContactReceived = createAction('CREATE_BUSINESS_CONTACT_RECEIVED');
export const createBusinessContactReceivedFailure = createAction('CREATE_BUSINESS_CONTACT_RECEIVED_FAILURE');
export const clearBusinessContact = createAction('CLEAR_BUSINESS_CONTACT');

export const createAnonymousBusinessContact = createAction('CREATE_ANONYMOUS_BUSINESS_CONTACT');
export const createAnonymousBusinessContactReceived = createAction('CREATE_ANONYMOUS_BUSINESS_CONTACT_RECEIVED');
export const createAnonymousBusinessContactReceivedFailure = createAction('CREATE_ANONYMOUS_BUSINESS_CONTACT_RECEIVED_FAILURE');
export const clearAnonymousBusinessContact = createAction('CLEAR_ANONYMOUS_BUSINESS_CONTACT');

export const exchangeBusinessCardRequested = createAction('EXCHANGE_BUSINESS_CARD_REQUESTED');
export const exchangeBusinessCardReceived = createAction('EXCHANGE_BUSINESS_CARD_Received');
export const exchangeBusinessCardReceiveFailure = createAction('EXCHANGE_BUSINESS_CARD_RECEIVED_FAILURE');
export const clearExchangeBusinessCard = createAction('CLEAR_EXCHANGE_BUSINESS_CARD');

export const GetExchangeBusinessCardRequested = createAction('GET_EXCHANGE_BUSINESS_CARD_REQUESTED');
export const GetExchangeBusinessCardReceived = createAction('GET_EXCHANGE_BUSINESS_CARD_Received');
export const GetExchangeBusinessCardReceiveFailure = createAction('GET_EXCHANGE_BUSINESS_CARD_RECEIVED_FAILURE');
export const ClearGetExchangeBusinessCard = createAction('CLEAR_GET_EXCHANGE_BUSINESS_CARD');

export const getUserProfileRequested = createAction('GET_USER_PROFILE_REQUESTED');
export const getUserProfileReceived = createAction('GET_USER_PROFILE_RECEIVED');
export const getUserProfileReceivedFailure = createAction('GET_USER_PROFILE_RECEIVED_FAILURE');
export const clearGetUserProfile = createAction('CLEAR_GET_USER_PROFILE');

export const getCompanyIdsByEventRequested = createAction('GET_COMPANY_IDS_BY_EVENT_REQUESTED');
export const getCompanyIdsByEventReceived = createAction('GET_COMPANY_IDS_BY_EVENT_RECEIVED');
export const getCompanyIdsByEventReceivedFailure = createAction('GET_COMPANY_IDS_BE_EVENT_RECEIVED_FAILURE');

export const addProductsToCartRequested = createAction('ADD_PRODUCT_TO_CART_REQUESTED');
export const addProductsToCartReceived = createAction('ADD_PRODUCT_TO_CART_RECEIVED');
export const addProductsToCartReceivedFailure = createAction('ADD_PRODUCT_TO_CART_RECEIVED_FAILURE');
export const clearProductsAddToCart = createAction('CLEAR_PRODUCTS_ADD_TO_CART');

